import { render } from "./ContactUsAgreement.vue?vue&type=template&id=604e60fc"
import script from "./ContactUsAgreement.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactUsAgreement.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContactUsAgreement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "604e60fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('604e60fc', __exports__)) {
    api.reload('604e60fc', __exports__)
  }
  
  module.hot.accept("./ContactUsAgreement.vue?vue&type=template&id=604e60fc", () => {
    api.rerender('604e60fc', render)
  })

}


export default __exports__